import { render, staticRenderFns } from "./GoalPanel.vue?vue&type=template&id=a83b6430"
import script from "./GoalPanel.vue?vue&type=script&lang=js"
export * from "./GoalPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports